import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JournalEntryDetailFormComponent } from './journal-entry-detail-form.component';
import { MatButtonModule } from '@angular/material/button';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ReactiveFormsModule } from '@angular/forms';
import { LoaderFormModule } from 'src/app/widgets/loaders/loader-form/loader-form.module';
import { HasClaimModule } from 'src/app/directives/has-claim/has-claim.module';


@NgModule({
  declarations: [JournalEntryDetailFormComponent],
  exports: [JournalEntryDetailFormComponent],
  imports: [
    CommonModule,
    LoaderFormModule,
    HasClaimModule,
    MatButtonModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatProgressSpinnerModule,
    ReactiveFormsModule
  ]
})
export class JournalEntryDetailFormModule { }
